import { ActionChipIcon } from '../components/display/ActionChip/ActionChipIcon';
import { Icon } from '@zapier/zinnia-icons';
import { ReactElement, ReactNode, isValidElement } from 'react';

const typeSet = new Set<string | Function>([
  'img',
  'svg',
  'picture',
  Icon,
  ActionChipIcon,
]);

export function isIconElement(element: ReactNode): element is ReactElement {
  return isValidElement(element) && typeSet.has(element.type);
}
